// Superadmin Route definitions
export const SUPERADMIN_ROUTES = {
  HOME: '/superadmin',
  LOGIN: '/superadmin/auth/login',
  DASHBOARD: '/superadmin/dashboard',
  USERS: '/superadmin/users',
  ROLES: '/superadmin/roles',
  PERMISSIONS: '/superadmin/permissions',
  ROLE_PERMISSIONS: '/superadmin/role-permissions',
  USER_PERMISSIONS: '/superadmin/user-permissions',
  TRANSACTIONS: '/superadmin/transactions',
  WEBHOOKS: '/superadmin/webhooks',
  SETTLEMENT: '/superadmin/settlement',
  PROFILE: '/superadmin/profile',
  NOT_FOUND: '/superadmin/404',
  UNAUTHORIZED: '/superadmin/unauthorized',
} as const;

export type SuperadminRouteKey = keyof typeof SUPERADMIN_ROUTES;
export type SuperadminRoutePath = (typeof SUPERADMIN_ROUTES)[SuperadminRouteKey];

